import { z } from 'zod';
import { UpsertPushAlarmInfoRequestBody } from '@/src/apis/rest/pushAlarm.dtos';

export const DEFAULT_VALUES: UpsertPushAlarmInfoRequestBody = {
  pushAlarmType: 'reservation',
  pushAlarmContentCategory: undefined,
  reservationTime: '',
  pushCategoryType: '',
  pushAlarmTitle: '',
  pushAlarmContent: '',
  pushAppPageConnectionCategory: '',
  pushAlarmContentId: undefined,
  pushContentType: 'appPageConnection',
};

export const formSchema = () => {
  return z.object({
    pushAlarmType: z.any(),
    pushAlarmContentCategory: z.any(),
    reservationTime: z.string(),
    pushCategoryType: z.string(),
    pushAlarmTitle: z.string(),
    pushAlarmContent: z.string(),
    pushAppPageConnectionCategory: z.any(),
    pushAlarmContentId: z.any(),
    pushContentType: z.any(),
  });
};

export const formFields = {
  pushAlarmType: {
    name: 'pushAlarmType',
  },
  reservationTime: {
    name: 'reservationTime',
  },
  pushProgressStatus: {
    name: 'pushProgressStatus',
  },
  pushCategoryType: {
    name: 'pushCategoryType',
  },
  pushAlarmTitle: {
    name: 'pushAlarmTitle',
  },
  pushAlarmContent: {
    name: 'pushAlarmContent',
  },
  pushAlarmContentType: {
    name: 'pushAlarmContentType',
  },
  pushAppPageConnectionCategory: {
    name: 'pushAppPageConnectionCategory',
  },
  pushAlarmContentId: {
    name: 'pushAlarmContentId',
  },
} as const;
